import { lazy } from 'react';

const Offers = lazy(() => import('../../admin/offers/AdminOffersPage'));

const ManagerOffersConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'manager/offers',
      element: <Offers />,
    },
  ],
};

export default ManagerOffersConfig;
